// Expando — render-prop disclosure primitive. Owns its own open/closed state
// so instances can be nested arbitrarily without parents threading keys or
// coordinating state. Pair with <ExpandoChevron> for the rotating indicator.
import { useState } from 'react'
import type { ReactNode } from 'react'
import { BsChevronDown } from 'react-icons/bs'

export interface ExpandoState {
    open: boolean
    toggle: () => void
    setOpen: (open: boolean) => void
}

export interface ExpandoProps {
    children: (state: ExpandoState) => ReactNode
    defaultOpen?: boolean
}

const Expando = ({ children, defaultOpen = false }: ExpandoProps) => {
    const [open, setOpen] = useState(defaultOpen)
    return <>{children({ open, toggle: () => setOpen((o) => !o), setOpen })}</>
}

export interface ExpandoChevronProps {
    open: boolean
    size?: number | string
}

export const ExpandoChevron = ({ open, size }: ExpandoChevronProps) => (
    <BsChevronDown
        size={size}
        style={{
            transition: 'transform 0.15s ease',
            transform: open ? 'rotate(-90deg)' : 'rotate(0deg)',
        }}
    />
)

export default Expando
